import ArtificialIntelligenceAssociationIcon from '../../../chicklets/associations/ArtificialIntelligenceAssociationIcon';
import RecordLink from 'crm-links/record/RecordLink';
import { useCallback } from 'react';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { Flex } from 'foundations-components/components/Flex';
import { DISPLAY_LABEL_FALLBACK } from '../../../constants/displayLabelFallback';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactChickletPrimaryDisplayLabel = ({
  toObjectId,
  toObjectTypeId,
  canView,
  properties,
  isAiAssociation
}) => {
  const handleTrackClick = useCallback(({
    objectId,
    objectTypeId
  }) => {
    CrmLogger.log('sidebar-interaction', {
      action: 'Clicked on the Primary Display Label',
      objectId: objectId.toString(),
      objectTypeId
    });
  }, []);
  const hsFullNameOrEmail = getPropertyValueFromProperties(properties, 'hs_full_name_or_email');
  const fullNameEmailOrFallback = hsFullNameOrEmail || DISPLAY_LABEL_FALLBACK;
  if (!canView) {
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "contact-chicklet-title",
      "data-test-id": "contact-chicklet-title",
      children: /*#__PURE__*/_jsx("strong", {
        "data-selenium-test": "contact-chicklet-title-read-only",
        "data-test-id": "contact-chicklet-title-read-only",
        "data-unit-test": "contact-chicklet-title-read-only",
        children: fullNameEmailOrFallback
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": "contact-chicklet-title",
    "data-test-id": "contact-chicklet-title",
    children: /*#__PURE__*/_jsx(RecordLink, {
      includeEschref: true,
      objectId: toObjectId,
      objectTypeId: toObjectTypeId,
      onTrackClick: handleTrackClick,
      children: /*#__PURE__*/_jsxs(Flex, {
        as: "span",
        alignItems: "center",
        "data-selenium-test": "contact-chicklet-title-link",
        "data-test-id": "contact-chicklet-title-link",
        children: [fullNameEmailOrFallback, isAiAssociation && /*#__PURE__*/_jsx(ArtificialIntelligenceAssociationIcon, {})]
      })
    })
  });
};
export default ContactChickletPrimaryDisplayLabel;